export const API_TOKEN_KEY = 'apiToken'
export const API_WORKSPACE_SLUG_KEY = 'apiWorkspaceSlug'

export default {
  /**
   * Gets and returns the API token in local storage
   * @returns {String}
   */
  getToken() {
    return localStorage.getItem(API_TOKEN_KEY)
  },

  /**
   * Sets and returns the API token in local storage
   * @param {String} token A new API token
   * @returns {String}
   */
  setToken(token) {
    localStorage.setItem(API_TOKEN_KEY, token)
    return token
  },

  /**
   * Clears and removes the API token in local storage
   * @returns {String}
   */
  clearToken() {
    localStorage.removeItem(API_TOKEN_KEY)
  },

  /**
   * Gets and returns the workspace key in local storage
   * @returns {String}
   */
  getWorkspaceSlug() {
    return localStorage.getItem(API_WORKSPACE_SLUG_KEY)
  },

  /**
   * Sets and returns the workspace key in local storage
   * @param {String} token A new workspace key
   * @returns {String}
   */
  setWorkspaceSlug(workspace) {
    localStorage.setItem(API_WORKSPACE_SLUG_KEY, workspace)
    return workspace
  },

  /**
   * Clears and removes the workspace key in local storage
   * @returns {String}
   */
  clearWorkspaceSlug() {
    localStorage.removeItem(API_WORKSPACE_SLUG_KEY)
  }
}
